export enum BankName {
  ANZ = 'ANZ',
  Macquarie = 'Macquarie'
}
